import { Node, mergeAttributes } from '@tiptap/react';

export type CalloutType = 'info' | 'warning' | 'success' | 'danger';

export const Callout = Node.create({
  name: 'callout',
  group: 'block',
  content: 'block+',
  defining: true,

  addAttributes() {
    return {
      type: {
        default: 'info' as CalloutType,
        parseHTML: element => element.getAttribute('data-callout-type') || 'info',
        renderHTML: attributes => ({
          'data-callout-type': attributes.type,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-callout]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-callout': '', class: 'callout' }), 0];
  },

  addKeyboardShortcuts() {
    return {
      // Enter at end of callout should exit it
      Enter: ({ editor }) => {
        const { state } = editor;
        const { $from } = state.selection;

        // Check if we're inside a callout
        let insideCallout = false;
        for (let d = $from.depth; d > 0; d--) {
          if ($from.node(d).type.name === 'callout') {
            insideCallout = true;
            break;
          }
        }

        if (!insideCallout) return false;

        // If the current block is empty, exit the callout
        const currentNode = $from.parent;
        if (currentNode.textContent === '' && currentNode.type.name === 'paragraph') {
          // Check if this is the last child
          const calloutDepth = (() => {
            for (let d = $from.depth; d > 0; d--) {
              if ($from.node(d).type.name === 'callout') return d;
            }
            return 0;
          })();

          if (calloutDepth > 0) {
            const calloutNode = $from.node(calloutDepth);
            const indexInCallout = $from.index(calloutDepth);
            if (indexInCallout === calloutNode.childCount - 1 && currentNode.textContent === '') {
              // Delete the empty paragraph and insert after callout
              const endPos = $from.end(calloutDepth);
              editor.chain()
                .deleteRange({ from: $from.before(), to: $from.after() })
                .insertContentAt(endPos - 1, { type: 'paragraph' })
                .focus()
                .run();
              return true;
            }
          }
        }

        return false;
      },
    };
  },
});
